import { createEffectFn } from '@ngneat/effects';
import { catchError, debounceTime, distinctUntilChanged, EMPTY, Observable, switchMap } from 'rxjs';

import { auditsService } from './audits.service';
import { AuditsState } from './audits.store';

type SearchAuditsParams = Partial<AuditsState>

export const searchAuditsEffect = createEffectFn((params$: Observable<SearchAuditsParams>) => {
  return params$.pipe(
    debounceTime(300),
    distinctUntilChanged(),
    switchMap(() => auditsService.getAudits().pipe(catchError(() => EMPTY))),
  );
});
